import { render, staticRenderFns } from "./AddQuotes.vue?vue&type=template&id=ba67d2b8&scoped=true&"
import script from "./AddQuotes.vue?vue&type=script&lang=js&"
export * from "./AddQuotes.vue?vue&type=script&lang=js&"
import style0 from "./AddQuotes.vue?vue&type=style&index=0&id=ba67d2b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba67d2b8",
  null
  
)

export default component.exports